'use strict';

var _enums = require('../enums');

var _enums2 = _interopRequireDefault(_enums);

var _isVisible = require('./isVisible');

var _isVisible2 = _interopRequireDefault(_isVisible);

var _isVisibleItself = require('./isVisibleItself');

var _isVisibleItself2 = _interopRequireDefault(_isVisibleItself);

var _isVisibleItselfAndNotCustom = require('./isVisibleItselfAndNotCustom');

var _isVisibleItselfAndNotCustom2 = _interopRequireDefault(_isVisibleItselfAndNotCustom);

var _isVisibleAndNotLiteAndCustom = require('./helpers/isVisibleAndNotLiteAndCustom');

var _isVisibleAndNotLiteAndCustom2 = _interopRequireDefault(_isVisibleAndNotLiteAndCustom);

var _mongoose = require('mongoose');

var _mongoose2 = _interopRequireDefault(_mongoose);

var _mongooseOptions = require('./mongooseOptions');

var _mongooseOptions2 = _interopRequireDefault(_mongooseOptions);

var _spaceAvailability = require('../spaceAvailability');

var _spaceAvailability2 = _interopRequireDefault(_spaceAvailability);

var _AddOn = require('./AddOn');

var _AddOn2 = _interopRequireDefault(_AddOn);

var _Delta = require('./Delta');

var _Delta2 = _interopRequireDefault(_Delta);

var _Space = require('../virtuals/Space');

var _Space2 = _interopRequireDefault(_Space);

var _lodash = require('lodash');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// virtuals


// Schemas
var seatingRequired = function seatingRequired(type) {
  return function () {
    var doc = this.parent ? this.parent() : this;
    if (doc.isLite || !doc.data.capacity) {
      return false;
    }

    return (0, _lodash.get)(doc, 'data.capacity.' + type + '.selected');
  };
};

// Lodash


var seatingMinMaxValidate = function seatingMinMaxValidate(type) {
  return function () {
    var doc = this.parent ? this.parent() : this;
    if (!seatingRequired(type).call(this)) {
      return true;
    }

    return doc.data.capacity[type].min > -1 && doc.data.capacity[type].max > -1 && doc.data.capacity[type].min <= doc.data.capacity[type].max;
  };
};

var schema = new _mongoose2.default.Schema({
  // Is this model visible to the world?
  isVisible: { type: Boolean, default: false },
  // Is this model deleted?
  // We are not going to delete data immediately, we will mark it as deleted
  // and batch clean them
  isDeleted: { type: Boolean, default: false },
  isCustom: { type: Boolean, default: false },
  isLite: { type: Boolean },

  // Admin - to be only edited by admins
  admin: {},
  order: {
    type: Number,
    default: 0
  },
  // Internal - to edited only by server/admins
  internal: {
    deltas: [_Delta2.default],
    // Array of 366 * 2 32-bit ints, each representing a given half-day
    // For instance, if today is January 2, 2015,
    // the 2nd to last bit on the first number is on iff January 1, 2016
    // @ 12:30am UTC is blocked,
    // and the last bit of the 5th number is on iff
    // January 3, 2015 @ 12:00am UTC is blocked.
    availability: [{
      type: Number,
      set: function set(v) {
        return Math.floor(v);
      }
    }]
  },
  data: {
    name: {
      type: String,
      required: [_isVisibleItself2.default, _enums2.default.validationErrors.Space.NO_NAME]
    },
    description: {
      type: String,
      required: [_isVisibleAndNotLiteAndCustom2.default, _enums2.default.validationErrors.Space.NO_DESCRIPTION],
      validate: [function (value) {
        var minLength = 10;
        if (_isVisibleItselfAndNotCustom2.default.call(this)) {
          return value && value.length >= minLength;
        } else {
          return true;
        }
      }, _enums2.default.validationErrors.Space.DESCRIPTION_TOO_SHORT]
    },
    privacy: {
      type: String,
      enum: _enums2.default.spacePrivacy,
      required: [_isVisibleAndNotLiteAndCustom2.default, _enums2.default.validationErrors.Space.NO_PRIVACY]
    },
    spaceType: {
      type: String,
      enum: _enums2.default.spaceTypes,
      required: [_isVisibleAndNotLiteAndCustom2.default, 'Space type is required']
    },

    // Capacity
    capacity: {
      seated: {
        selected: { type: Boolean, default: false },
        min: {
          type: Number,
          required: [seatingRequired('seated'), 'Seated capacity minimum is required'],
          validate: {
            validator: seatingMinMaxValidate('seated'),
            message: 'Invalid seated capacity minimum'
          }
        },
        max: {
          type: Number,
          required: [seatingRequired('seated'), 'Seated capacity maximum is required'],
          validate: {
            validator: seatingMinMaxValidate('seated'),
            message: 'Invalid seated capacity max'
          }
        },
        style: [{
          type: String,
          enum: _enums2.default.capacityStyles.seated,
          required: [seatingRequired('seated'), _enums2.default.validationErrors.Space.NO_SEATED_CAPACITY_STYLE]
        }]
      },
      standing: {
        selected: { type: Boolean, default: false },
        min: {
          type: Number,
          required: [seatingRequired('standing'), 'Standing capacity minimum is required'],
          validate: {
            validator: seatingMinMaxValidate('standing'),
            message: 'Invalid standing capacity minimum'
          }
        },
        max: {
          type: Number,
          required: [seatingRequired('standing'), 'Standing capacity maximum is required'],
          validate: {
            validator: seatingMinMaxValidate('standing'),
            message: 'Invalid standing capacity maximum'
          }
        },
        style: [{
          type: String,
          enum: _enums2.default.capacityStyles.standing,
          required: [seatingRequired('standing'), _enums2.default.validationErrors.Space.NO_STANDING_CAPACITY_STYLE]
        }]
      }
    },
    amenities: [{
      type: String,
      enum: _enums2.default.spaceAmenities
    }],
    addOns: [_AddOn2.default],
    custom: {
      amenities: [{ type: String }],
      addOns: [_AddOn2.default]
    },

    // Hidden elements
    hidden: {
      fbMin: {
        type: Boolean
      }
    },

    // Terms
    terms: {
      // Max duration, in minutes
      duration: {
        type: Number,
        required: [_isVisibleAndNotLiteAndCustom2.default, 'Duration is required'],
        default: 120
      },
      extraHourPolicy: {
        type: String,
        enum: _enums2.default.extraHourPolicy.ALL,
        required: [_isVisibleAndNotLiteAndCustom2.default, 'Extra hour policy is required']
      },
      extraHourFee: Number
    },

    // Timeslots
    timeSlots: [{
      name: {
        type: String
      },

      // isCustom - purely for requests to log past events
      isCustom: { type: Boolean, default: false },

      // 07:30am =>  730
      from: {
        type: Number
      },
      // 07:30pm => 1930
      to: {
        type: Number
      },
      days: {
        type: Array,
        // days[0] = false  => Space is *not* available on Sundays
        // days[1] = true   => Space is available on Mondays
        default: [false, false, false, false, false, false, false],
        validate: [function (value) {
          if (_isVisibleItselfAndNotCustom2.default.call(this)) {
            return (0, _lodash.reduce)(value, function (p, n) {
              return p || n;
            }, false);
          } else return true;
        }, 'Please select at least one day', 'min_one_day']
      },
      terms: {
        foodBeverageMin: {
          type: Number
        },
        extraHourFee: {
          type: Number
        },
        roomFeeCents: {
          type: Number
        }
      }
    }],
    coverIndex: { type: Number, default: 0 },
    photos: [{
      caption: String,
      url: String
    }],
    roomSetup: { type: String }
  }
}, _mongooseOptions2.default);

schema.path('data.photos').validate(function (photos) {
  if (this.isLite) {
    return true;
  }
  if (_isVisibleItselfAndNotCustom2.default.call(this) && _isVisible2.default.call(this) && !(this.data.photos || []).length) {
    return false;
  }
  return true;
}, _enums2.default.validationErrors.Space.NO_PHOTO);

schema.path('data.capacity.seated.style').validate(function () {
  if (this.isLite) {
    return true;
  }
  if (!this.data.capacity) {
    return true;
  }

  var path = this.data.capacity.seated;
  if (_isVisibleItselfAndNotCustom2.default.call(this) && _isVisible2.default.call(this) && (0, _lodash.get)(path, 'selected') && !(path.style || ['']).length) {
    return false;
  }

  return true;
}, _enums2.default.validationErrors.Space.NO_SEATED_CAPACITY_STYLE, _enums2.default.validationErrors.EMPTY_ARRAY);

schema.path('data.capacity.standing.style').validate(function () {
  if (this.isLite) {
    return true;
  }
  if (!this.data.capacity) {
    return true;
  }

  var path = this.data.capacity.standing;
  if (_isVisibleItselfAndNotCustom2.default.call(this) && _isVisible2.default.call(this) && (0, _lodash.get)(path, 'selected') && !(path.style || ['']).length) {
    return false;
  }

  return true;
}, _enums2.default.validationErrors.Space.NO_STANDING_CAPACITY_STYLE, _enums2.default.validationErrors.EMPTY_ARRAY);

schema.path('data.capacity.seated.selected').validate(function () {
  if (this.isLite) {
    return true;
  }
  if (_isVisibleItselfAndNotCustom2.default.call(this) && _isVisible2.default.call(this)) {
    var seatedSelected = (0, _lodash.get)(this, 'data.capacity.seated.selected');
    var standingSelected = (0, _lodash.get)(this, 'data.capacity.standing.selected');
    return seatedSelected || standingSelected;
  }
  return true;
}, _enums2.default.validationErrors.Space.NO_CAPACITY_SELECTED);

schema.path('data.capacity.standing.selected').validate(function () {
  if (this.isLite) {
    return true;
  }
  if (_isVisibleItselfAndNotCustom2.default.call(this) && _isVisible2.default.call(this)) {
    var seatedSelected = (0, _lodash.get)(this, 'data.capacity.seated.selected');
    var standingSelected = (0, _lodash.get)(this, 'data.capacity.standing.selected');
    return seatedSelected || standingSelected;
  }
  return true;
}, _enums2.default.validationErrors.Space.NO_CAPACITY_SELECTED);

schema.virtual('coverImage').get(function () {
  if (this.data.photos && this.data.photos.length && this.data.photos.length >= this.data.coverIndex) {
    return this.data.photos[this.data.coverIndex];
  }
  return {
    url: '//res.cloudinary.com/dbwijvnzn/image/upload/v1453314075/placeholder_xj1wzt.jpg'
  };
});

schema.virtual('schemaType').get(function () {
  return 'Space';
});

schema.virtual('showFbMin').get(function () {
  return _Space2.default.showFbMin(this);
});

/**
 * List of durations and associated times that you can start at.
 *
 * @param {String} date YYYY-MM-DD
 * @param {Number} time HHmm
 * @param {Number} groupSize number of people to accommodate
 * @param {Boolean} flexible if true, allow flexibility margin in getting availability
 * @return {Array} [{ duration: Number, times: [Number] }]
 */

schema.methods.getAvailability = function (date, time, groupSize, flexible) {
  return _spaceAvailability2.default.getAvailability(this, date, time, groupSize, flexible);
};

/**
 * Find a time slot for the given date and time
 *
 * @param {String} date YYYY-MM-DD
 * @param {Number} time HHmm
 * @param {Number} [duration] Optional, in minutes
 * @return {Object} the associated element in the timeSlots array
 */

schema.methods.getTimeSlot = function (date, time, duration, flexible) {
  var index = _spaceAvailability2.default.getTimeSlot(this, date, time, duration, flexible);
  return index === -1 ? null : this.data.timeSlots[index];
};

/**
 * Gets the room fee in cents for a slot and converts it to dollars
 *
 * @method
 * @params {Slot}
 * @return {Number}
 */
schema.methods.getRoomFeeDollars = function (slot) {
  var fee = (0, _lodash.get)(slot, 'terms.roomFeeCents', 0);
  return (0, _lodash.round)(fee / 100, 2);
};

/**
 * Can this space accommodate the given group size at the given date and time?
 * Currently doesn't distinguish between seated and standing.
 *
 * @param {String} date YYYY-MM-DD
 * @param {Number} time HHmm
 * @param {Number} groupSize number of people to accommodate
 * @param {Number} [duration] optional duration in minutes
 * @return {Boolean}
 */

schema.methods.isAvailable = function (date, time, groupSize, duration, flexible) {
  return _spaceAvailability2.default.isAvailable(this, date, time, groupSize, duration, flexible);
};

schema.methods.getMaxCapacity = function () {
  var seatedMax = (0, _lodash.get)(this, 'data.capacity.seated.max');
  var standingMax = (0, _lodash.get)(this, 'data.capacity.standing.max');

  return (0, _lodash.max)([seatedMax, standingMax]);
};

schema.methods.getMinCapacity = function () {
  var seatedMin = (0, _lodash.get)(this, 'data.capacity.seated.min');
  var standingMin = (0, _lodash.get)(this, 'data.capacity.standing.min');

  return (0, _lodash.min)([seatedMin, standingMin]);
};

schema.virtual('schemaType').get(function () {
  return 'Space';
});

module.exports = schema;